<div class="text-block-wrapper">
  <div
    *ngIf="titleContent"
    class="text-block"
    [ngClass]="{
      'text-block--left': titleAlign === TextBlockAlign.LEFT,
    }"
  >
    <ng-container [ngSwitch]="titleVariant">
      <h1
        *ngSwitchCase="TextBlockTitleVariant.H1"
        [innerHtml]="titleContent.trim()"
      ></h1>
      <h2
        *ngSwitchCase="TextBlockTitleVariant.H2"
        [innerHtml]="titleContent.trim()"
      ></h2>
    </ng-container>
  </div>
  <div
    *ngIf="paragraph"
    class="text-block"
    [ngClass]="{
      'text-block--left': paragraphAlign === TextBlockAlign.LEFT,
    }"
  >
    <p class="text-block__paragraph" [innerHtml]="paragraph"></p>
  </div>
</div>
